









































import { Component, Prop, Vue } from 'vue-property-decorator';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TAcquisition, TPatient } from '@/plugins/podolib/services/entities/EntityPatients';

@Component
export default class PatientAcquisitionExportationFrameRunningContainerChartRunningPhaseRunSteps extends Vue {
  @Prop({ required: true }) private patient!: TEntity<TPatient>;
  @Prop({ required: true }) private acquisition!: TEntity<TAcquisition>;

  // -- CALCULS --------------------------------------------------------------------------------------------------------

  getData(side: string, data: string) {
    return parseFloat(this.acquisition!.computed_data.aggregates[side][data].avg.toFixed(1));
  }
  get doubleContact() {
    let flight_time = (this.getData('left', 'percent_flight_time') + this.getData('right', 'percent_flight_time')) / 2;
    let contact_time =
      (this.getData('left', 'percent_contact_time') + this.getData('right', 'percent_contact_time')) / 2;
    return ((flight_time - contact_time) / 2).toFixed(0);
  }
}
